import { useEffect, useState } from 'react';
import { fetchUserVins, type UserVinItem } from './api.js';

function formatLastUsed(value: string): string {
  const date = new Date(value.replace(' ', 'T') + (/[zZ]|[+-]\d\d:\d\d$/.test(value) ? '' : 'Z'));
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow', day: 'numeric', month: 'long', year: 'numeric',
  }).format(date);
}

export function VinPicker({ initData, currentVin, refreshKey, onSelect, onManualEntry }: {
  initData: string;
  currentVin: string;
  refreshKey?: string | number;
  onSelect: (vin: string) => void;
  onManualEntry: () => void;
}) {
  const [items, setItems] = useState<UserVinItem[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!initData) return;
    fetchUserVins(initData)
      .then((response) => { if (!cancelled && response.ok) setItems(response.items ?? []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [initData, refreshKey]);

  if (items.length === 0) return null;

  return <>
    <button className="vin-picker__trigger" type="button" onClick={() => setOpen(true)}>
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M7 4v6M17 4v6M6 13h5M6 17h8" /></svg>
      <span>Выбрать из моих VIN</span>
      <strong>{items.length}</strong>
      <svg className="vin-picker__chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>
    </button>
    {open ? <div className="modal-overlay" onClick={() => setOpen(false)}>
      <section className="modal vin-picker" role="dialog" aria-modal="true" aria-labelledby="vin-picker-title"
        onClick={(event) => event.stopPropagation()}>
        <div className="vin-picker__heading">
          <div>
            <h2 className="modal__title" id="vin-picker-title">Мои VIN</h2>
            <p>Выберите номер из прежних обращений</p>
          </div>
          <button className="vin-picker__close" type="button" aria-label="Закрыть" onClick={() => setOpen(false)}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" /></svg>
          </button>
        </div>
        <ul className="vin-picker__list">
          {items.map((item) => <li key={item.vin}>
            <button className="vin-picker__option" type="button" aria-pressed={currentVin === item.vin}
              onClick={() => { onSelect(item.vin); setOpen(false); }}>
              <span className="vin-picker__details">
                <strong>{item.vin}</strong>
                {item.article ? <span>Артикул: {item.article}</span> : null}
                {item.name ? <span>Наименование: {item.name}</span> : null}
                {!item.article && !item.name
                  ? <span>{item.model ? <>Модель: {item.model}</> : 'Данные изделия не определены'}</span>
                  : null}
                <small>Использовался {formatLastUsed(item.last_used_at)}</small>
              </span>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4L19 6" /></svg>
            </button>
          </li>)}
        </ul>
        <button className="modal__cancel vin-picker__manual" type="button" onClick={() => {
          onManualEntry(); setOpen(false);
        }}>Ввести другой VIN</button>
      </section>
    </div> : null}
  </>;
}
